import { useTheme } from 'styled-components';
import { Button, Divider, Flex, Typography } from '~/ui/components';
import { Warning } from '~/ui/assets/icons';
import { useModal } from '~/hooks/useModal';

type Props = {
  modalId?: string;
};

export function QuitacaoUnavailableModal({ modalId }: Props) {
  const theme = useTheme();
  const primaryColor = theme?.colors?.primary?.main || '#C4125D';
  const { closeModal } = useModal();

  return (
    <Flex direction="column" gap={16}>
      <Warning width={40} height={40} color={primaryColor} />

      <Flex direction="column" gap={8}>
        <Typography type="headingSmall">Pagar parcela indisponível</Typography>
        <Typography type="bodySmall" color="element.secondary">
          No momento o serviço está indisponível, porque não foi possível cancelar o acordo em andamento. Por favor,
          tente novamente mais tarde.
        </Typography>
      </Flex>

      <Divider lineType="solid" />

      <Flex justify="flex-end">
        <Button variant="contained" onClick={() => modalId && closeModal(modalId)}>
          Fechar
        </Button>
      </Flex>
    </Flex>
  );
}

export const QUITACAO_RETURN_CODE_UNAVAILABLE = 99;

export function useQuitacaoUnavailableGuard() {
  const { openModal } = useModal();

  return (data: any): boolean => {
    if (data?.returnCode !== QUITACAO_RETURN_CODE_UNAVAILABLE) return false;

    openModal(<QuitacaoUnavailableModal />, {
      title: 'Pagar parcela indisponível',
      width: 480,
      closable: true,
    });
    return true;
  };
}
